import * as React from "react";
import { useFocusEffect } from "expo-router";

import SaveFormEditLink from "~/components/SaveForm/SaveForm.editLink";
import { useSaveFormContext } from "~/components/SaveForm/shared";

export default function EditLinkPage() {
  const { setValue } = useSaveFormContext();

  useFocusEffect(() => {
    setValue("step", "editUrl");
  });
  return <SaveFormEditLink />;
}
